import { render } from "./ImageCropResizeSettings.vue?vue&type=template&id=9a2981e0&scoped=true&ts=true"
import script from "./ImageCropResizeSettings.vue?vue&type=script&lang=ts"
export * from "./ImageCropResizeSettings.vue?vue&type=script&lang=ts"

import "./ImageCropResizeSettings.vue?vue&type=style&index=0&id=9a2981e0&scoped=true&lang=scss"

import exportComponent from "/home/appstore/appstore/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a2981e0"]])

export default __exports__